import { yupResolver } from '@hookform/resolvers/yup';
import type { FieldValues, Resolver } from 'react-hook-form';

/**
 * `yupResolver` types a form by its schema, but our schemas validate only part of each form:
 * UI-only toggles and programmatically set fields have no rules. This resolver leaves the form
 * type to `useForm` (its generic or its `defaultValues`); validation behaves exactly as
 * `yupResolver`.
 */
export const formResolver = <T extends FieldValues>(
  schema: Parameters<typeof yupResolver>[0],
): Resolver<T> => yupResolver(schema) as unknown as Resolver<T>;
